import { useTranslation } from 'react-i18next';

function VoiceInput({ isListening, isSpeaking, answer, onStart, onStop }) {
    const { t } = useTranslation();

    return (
        <div className="voice-input-section">
            <div className={`voice-visualizer ${isListening ? 'listening' : ''}`}>
                {isListening ? (
                    <>
                        <div className="voice-bar" />
                        <div className="voice-bar" />
                        <div className="voice-bar" />
                        <div className="voice-bar" />
                        <div className="voice-bar" />
                    </>
                ) : (
                    <span className="voice-idle-icon">🎤</span>
                )}
            </div>

            {answer && (
                <div className="transcript-box">
                    <strong>{t('interview.your_answer')}:</strong>
                    <p>{answer}</p>
                </div>
            )}

            <div className="voice-controls">
                {!isListening ? (
                    <button
                        onClick={onStart}
                        className="voice-btn start-btn"
                        disabled={isSpeaking}
                    >
                        {t('interview.start_speaking')}
                    </button>
                ) : (
                    <button onClick={onStop} className="voice-btn stop-btn">
                        {t('interview.stop_speaking')}
                    </button>
                )}
            </div>

            <small className="hint" style={{ textAlign: 'center', display: 'block', marginTop: '0.5rem' }}>
                {t('interview.voice_hint')}
            </small>
        </div>
    );
}

export default VoiceInput;